import api from "../../services/api";

// Cache por sessão E por empresa: a lista de agentes e as filas mudam
// raramente e o useTicketAI é montado a cada troca de ticket — evita GET
// /prompt + GET /queue por render. Trocar de empresa (outro login na mesma
// aba, sem recarregar) descarta o cache, para não mostrar agentes de outra
// empresa. Também é invalidado pelos eventos company-<id>-prompt e
// company-<id>-queue (vínculo novo, fila ganhou chatbot), e quem está
// montado recarrega via `ouvintes`.
let dadosCache = null;
let dadosPromise = null;
let empresaDoCache = null;
export const ouvintes = new Set();

const VAZIO = { prompts: [], filas: [] };

const descarta = () => {
  dadosCache = null;
  dadosPromise = null;
  empresaDoCache = null;
};

export const dadosEmCache = (companyId) =>
  dadosCache && empresaDoCache === companyId ? dadosCache : null;

export const carregaDados = async (companyId) => {
  if (empresaDoCache !== companyId) descarta();
  if (dadosCache) return dadosCache;
  if (!dadosPromise) {
    empresaDoCache = companyId;
    const promessa = Promise.all([
      api.get("/prompt", { params: { all: true } }),
      api.get("/queue"),
    ])
      .then(([{ data: prompts }, { data: filas }]) => {
        const dados = {
          prompts: Array.isArray(prompts?.prompts) ? prompts.prompts : [],
          filas: Array.isArray(filas) ? filas : [],
        };
        // Invalidado ou trocou de empresa no meio do caminho: não grava
        // dado velho no cache.
        if (dadosPromise === promessa) dadosCache = dados;
        return dados;
      })
      .catch(() => {
        if (dadosPromise === promessa) dadosPromise = null;
        return VAZIO;
      });
    dadosPromise = promessa;
  }
  return dadosPromise;
};

export const invalidaCache = () => {
  descarta();
  ouvintes.forEach((recarrega) => recarrega());
};
